/**
 * @file updateSearchItem.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Dec 14, 2022 21:54
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    DOCUMENT_UPDATE_SEARCH_ITEM_REQUEST,
    documentUpdateSearchItemSuccess,
    documentUpdateSearchItemFailure,
} from 'src/store/actions/document/documentDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/document/updateSearchItem';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            docType: payload.docType,
            docId: payload.docId,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* searchRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);
        yield put(documentUpdateSearchItemSuccess(resp.payload));

    } catch (error) {
        yield put(documentUpdateSearchItemFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }
}

export default function* searchRequestMonitor() {
    yield takeLatest(DOCUMENT_UPDATE_SEARCH_ITEM_REQUEST, searchRequestSaga);
}
